import { __, compose, converge, propOr, always } from 'ramda';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

import toggleProp from 'app/libs/toggleProp';
import { pickState, propFromPayload } from 'app/reducers/helpers';
import { USER_FETCHED } from 'app/features/user/actionTypes';
import { SUPER_FAN } from 'app/features/user/constants/accessTypes';
import { QUESTION_SELECTED } from 'app/features/success/helpCenterBlock/actionTypes';

const faqInitialState = {
  'crunchyroll-store': false,
  'munch-pak': false,
  'right-stuff-anime': false,
};

const faqByAccessType = { [SUPER_FAN]: faqInitialState };

const faq = handleActions(
  {
    [USER_FETCHED]: compose(
      propOr(null, __, faqByAccessType),
      propFromPayload('accessType'),
    ),
    [QUESTION_SELECTED]: converge(toggleProp, [
      propFromPayload('anchor'),
      pickState,
    ]),
  },
  null,
);

const helpCenterBlock = combineReducers({ isVisible: always(true), faq });

export { faq };

export default helpCenterBlock;
